export class ObjectTable {
    Id: number | null;
    Name: string;
    Code: string;
    IsClosedTable: boolean;
    IsLookUp: boolean;
    HasDocuments: boolean;
    HasPermission: boolean;
    ShowInWorkFlows: boolean;
    LookupDisplayObjectFieldCode: string;
}